import { Employee } from "./employee";
import { Departament } from "./departament";
import { UserCalendarStats } from "./userCalendarStats";

export class DashboardEmployee {
    public employee: Employee
    public calendar_stats: UserCalendarStats
}

export class DashboardEmployeeItem {
    public id: number
    public full_name: string
    public department: Departament
}

export class DashboardEmployeeCalendarStats {
    public totalHolidays: number
    public totalPersonalMatters: number
    public totalSickLeave: number
    public totalPaidLeave: number
    public totalRemoteWork: number
    public totalHolidaysPrevYear: number

    constructor(
        totalHolidays: number,
        totalPersonalMatters: number,
        totalSickLeave: number,
        totalPaidLeave: number,
        totalRemoteWork: number,
        totalHolidaysPrevYear: number
    ) {
        this.totalHolidays = totalHolidays
        this.totalPersonalMatters = totalPersonalMatters
        this.totalSickLeave = totalSickLeave
        this.totalPaidLeave = totalPaidLeave
        this.totalRemoteWork = totalRemoteWork
        this.totalHolidaysPrevYear = totalHolidaysPrevYear
    }
}